const CLOUDINARY_SHARED_BASE_URL = 'https://res.cloudinary.com';

const trimTrailingSlash = (value = '') => String(value || '').trim().replace(/\/+$/, '');

export const getCloudinaryCloudName = () =>
  String(process.env.NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME || '').trim();

export const getCloudinaryDeliveryBaseUrl = () => {
  const configuredBaseUrl = trimTrailingSlash(process.env.NEXT_PUBLIC_CLOUDINARY_DELIVERY_BASE_URL);

  if (configuredBaseUrl) {
    return configuredBaseUrl;
  }

  const cloudName = getCloudinaryCloudName();
  return cloudName ? `${CLOUDINARY_SHARED_BASE_URL}/${cloudName}` : '';
};

export const isCloudinaryAssetUrl = (value = '') => {
  const assetUrl = String(value || '').trim();
  if (!assetUrl) return false;

  const cloudName = getCloudinaryCloudName();
  if (!cloudName) return false;

  return assetUrl.startsWith(`${CLOUDINARY_SHARED_BASE_URL}/${cloudName}/`);
};

export const resolveMediaUrl = (value = '') => {
  const assetUrl = String(value || '').trim();
  if (!assetUrl || !isCloudinaryAssetUrl(assetUrl)) {
    return assetUrl;
  }

  const cloudName = getCloudinaryCloudName();
  const defaultBaseUrl = `${CLOUDINARY_SHARED_BASE_URL}/${cloudName}`;
  const deliveryBaseUrl = getCloudinaryDeliveryBaseUrl();

  if (!deliveryBaseUrl || deliveryBaseUrl === defaultBaseUrl) {
    return assetUrl;
  }

  return `${deliveryBaseUrl}${assetUrl.slice(defaultBaseUrl.length)}`;
};

export const getCanonicalMediaUrl = (value = '') => {
  const assetUrl = String(value || '').trim();
  if (!assetUrl) return assetUrl;

  const cloudName = getCloudinaryCloudName();
  if (!cloudName) return assetUrl;

  const defaultBaseUrl = `${CLOUDINARY_SHARED_BASE_URL}/${cloudName}`;
  const deliveryBaseUrl = getCloudinaryDeliveryBaseUrl();

  if (!deliveryBaseUrl || deliveryBaseUrl === defaultBaseUrl || !assetUrl.startsWith(deliveryBaseUrl)) {
    return assetUrl;
  }

  return `${defaultBaseUrl}${assetUrl.slice(deliveryBaseUrl.length)}`;
};
